import { Box } from '@mui/material'
import { buildComposerMainGridClassName } from './buildComposerMainGridClassName'
import AiAskBarComposerEditorSlot from './AiAskBarComposerEditorSlot'
import AiAskBarDictationWaveformRow from './AiAskBarDictationWaveformRow'
import AiAskBarLeftActions from './AiAskBarLeftActions'
import AiAskBarRightActionsComposer from './AiAskBarRightActionsComposer'

export default function AiAskBarComposerMainGrid(props) {
  const { vm, actions, mentionMembers, mentionAgents, onDiscard, sendDisabled, onVoiceToggle, voiceActive } = props

  return (
    <Box className={buildComposerMainGridClassName(vm)}>
      <AiAskBarComposerEditorSlot vm={vm} actions={actions} mentionMembers={mentionMembers} mentionAgents={mentionAgents} />
      <AiAskBarLeftActions
        showAttach={!vm.isEmailReply}
        // Previously gated on `onOpenConnections`, which nothing passes — so the
        // button never rendered and the integrations modal had no live trigger.
        // The overlay already falls back to the modal context when no handler
        // is supplied.
        showConnections={!vm.isEmailReply}
        attachments={vm.attachments}
        handleOpenFilePicker={actions.handleOpenFilePicker}
        onSelectFromDocuments={actions.handleOpenDocumentsPicker}
        connectionsButtonRef={vm.connectionsButtonRef}
        setConnectionsOpen={vm.setConnectionsOpen}
      />
      <AiAskBarDictationWaveformRow isDictating={vm.isDictating} levels={vm.levels} minBarPx={vm.minBarPx} maxBarPx={vm.maxBarPx} />
      <AiAskBarRightActionsComposer vm={vm} actions={actions} onDiscard={onDiscard} sendDisabled={sendDisabled} onVoiceToggle={onVoiceToggle} voiceActive={voiceActive} />
    </Box>
  )
}
